import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { HighlightedPriceDisplay } from 'pricing-pages-ui/components/common/pricing/HighlightedPriceDisplay';
import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import { calculatedPriceSelector } from 'pricing-pages-ui/selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { quantityPackProductConfigurationsFromProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { useQueryParamTerm, useValidatedCrmSuiteQueryParamTerm } from 'pricing-pages-ui/utils/urls/queryParamUtils';
import { useSelector } from 'react-redux';
import { skuIdHasBundledProductsSelector } from '../../../selectors/ProductsSelectors';
export const CrmSuitePrice = (_ref) => {
  let {
    productLevel,
    termOverride
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["productLevel", "termOverride"]);

  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const {
    queryParamTerm: unbundledQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const bundledQueryParamTerm = useSelector(state => {
    const hasBundledSuite = suiteProductConfigurations.find(config => skuIdHasBundledProductsSelector(state, {
      skuId: config.skuId
    }));
    return hasBundledSuite ? queryParamTerm : null;
  });
  const ownedQuantityPackProductConfigurations = useSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...ownedQuantityPackProductConfigurations];
  const pricingInfo = useSelector(reduxState => {
    if (!hasPricingAndPurchasingSucceeded) return null;
    return calculatedPriceSelector(reduxState, {
      productConfigurations: checkoutProductConfigurations,
      queryParamTerm: termOverride || bundledQueryParamTerm || unbundledQueryParamTerm
    });
  });
  return /*#__PURE__*/_jsx(HighlightedPriceDisplay, Object.assign({
    pricingInfo: pricingInfo,
    nonMerchandiseIdProduct: SuiteProductLevelIdentifiersMap[productLevel]
  }, restProps));
};